interface ContactInfoProps {
  className?: string;
  title: string;
  pageName: string;
}

export default function ContactInfo({ title, pageName }: ContactInfoProps) {
  return (
    <section className="flex justify-start w-full">
      <div className="flex flex-col text-left text-white gap-2">
        <h3 className="text-3xl font-bold text-fb-primary">{title}</h3>
        <p className="text-slate-900 font-bold">
          For inquiries regarding this {pageName}, please contact:
        </p>
        <p className="text-slate-900">File Business LLC</p>
        <p className="text-slate-900">101 N Monroe Rd, Suite 800 Tallahassee, FL 32301
        </p>
        <p className="text-slate-900">Email: info@file.business
        </p>
        <p className="text-slate-900">Phone: (850) 666-5402</p>
        <p className="text-slate-900 font-bold">
          By using our Website and Services, you acknowledge and agree to this legally binding {pageName}.
        </p>
      </div>
    </section>
  );
}